import { TwoCol, SubSection } from "./fundCardHelpers";
import { InfoRow, AlertBanner } from "../UI";
import { fmtMoney } from "../../parsers/xmlParser";
import { getFundClass } from "../../utils/reportComputations";

export default function FinancialTab({ fund, cs, redeem, hk, sumPitzuyim, sumTagmulim }) {
  const hasDebt = !!fund.debts;
  const hasLoan = !!fund.loan;
  const fundClass = getFundClass(fund);
  return (
    <>
      <TwoCol>
        <SubSection title="סיכום צבירה" color={cs.accent}>
          <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 12 }}>
            <div style={{ padding: 12, background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
              <div style={{ fontWeight: 800, fontSize: 13, marginBottom: 6 }}>סה״כ צבירה לחשבון</div>
              <div style={{ color: cs.accent, fontWeight: 800, fontSize: 18 }}>{fmtMoney(redeem)}</div>
              {(() => {
                const totalHon    = hk.hon + hk.honPitzuyim;
                const totalPre    = (hk.preReform || 0) + (hk.preReformPitzuyim || 0) + (hk.kitzbaPreSettlement || 0);
                const totalKitzba = hk.kitzba - (hk.kitzbaPreSettlement || 0) + hk.kitzbaPitzuyim;
                return (
                  <div style={{ fontSize: 11, color: "#64748b", marginTop: 2, display: "flex", flexDirection: "column", gap: 1 }}>
                    {totalHon    > 0 && <span>להון: {fmtMoney(totalHon)}</span>}
                    {totalPre    > 0 && <span>קצבה עד 2000: {fmtMoney(totalPre)}</span>}
                    {totalKitzba > 0 && <span>{fundClass === "קצבה משלמת" ? "קצבה משלמת" : "קצבה לא משלמת"}: {fmtMoney(totalKitzba)}{hk.kitzba190 > 0 ? ` (כולל ${fmtMoney(hk.kitzba190)} תיקון 190)` : ""}</span>}
                  </div>
                );
              })()}
            </div>
            <div className="responsive-two-col" style={{ gap: 10 }}>
              <div style={{ padding: 10, background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 4 }}>תגמולים</div>
                <div style={{ fontSize: 16, fontWeight: 800, color: "#2563eb" }}>{fmtMoney(sumTagmulim)}</div>
                <div style={{ fontSize: 11, color: "#64748b", marginTop: 2, display: "flex", flexDirection: "column", gap: 1 }}>
                  {(() => {
                    const pre = (hk.kitzbaPreSettlement || 0) + (hk.preReform || 0);
                    const post = hk.kitzba - (hk.kitzbaPreSettlement || 0);
                    return (<>
                      {hk.hon > 0 && <span>להון: {fmtMoney(hk.hon)}{hk.hon190 > 0 ? ` (כולל ${fmtMoney(hk.hon190)} תיקון 190)` : ""}</span>}
                      {pre  > 0 && <span>קצבה עד 2000: {fmtMoney(pre)}</span>}
                      {post > 0 && <span>{fundClass === "קצבה משלמת" ? "קצבה משלמת" : "קצבה לא משלמת"}: {fmtMoney(post)}{hk.kitzba190 > 0 ? ` (כולל ${fmtMoney(hk.kitzba190)} תיקון 190)` : ""}</span>}
                    </>);
                  })()}
                </div>
              </div>
              {sumPitzuyim > 0 && (
                <div style={{ padding: 10, background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 4 }}>פיצויים</div>
                  <div style={{ fontSize: 16, fontWeight: 800, color: "#e11d48" }}>{fmtMoney(sumPitzuyim)}</div>
                  {(hk.honPitzuyim > 0 || hk.kitzbaPitzuyim > 0 || (hk.preReformPitzuyim || 0) > 0) && (
                    <div style={{ fontSize: 11, color: "#64748b", marginTop: 2, display: "flex", flexDirection: "column", gap: 1 }}>
                      {hk.honPitzuyim > 0 && <span>להון: {fmtMoney(hk.honPitzuyim)}</span>}
                      {(hk.preReformPitzuyim || 0) > 0 && <span>נתון לבחירת לקוח: {fmtMoney(hk.preReformPitzuyim)}</span>}
                      {hk.kitzbaPitzuyim > 0 && <span>{fundClass === "קצבה משלמת" ? "קצבה משלמת" : "קצבה לא משלמת"}: {fmtMoney(hk.kitzbaPitzuyim)}</span>}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {fund.yitrot?.pitzuyim && (
            <>
              <InfoRow label="פיצויים ללא התחשבנות" value={fund.yitrot.pitzuyim.yitratPitzuim} money />
              <InfoRow label="פיצויים לקצבה" value={fund.yitrot.pitzuyim.pitzuyimLekitzba} money />
            </>
          )}
          <InfoRow label="נזילות תגמולים מתאריך" value={fund.yitrot?.tagmulimLiquidity} />
          <InfoRow label="יתרה ל-" value={fund.yitrot?.date} />
        </SubSection>
        <SubSection title="דמי ניהול" color={cs.accent}>
          <InfoRow label="דמי ניהול מהפקדה %" value={fund.dmeiNihul?.actual?.dmeiHafPct} pct />
          <InfoRow label="דמי ניהול מהפקדה ₪" value={fund.dmeiNihul?.actual?.dmeiHafAmt} money />
          <InfoRow label="דמי ניהול מצבירה %" value={fund.dmeiNihul?.actual?.dmeiTzvPct} pct />
          {fund.dmeiNihul?.actual?.profitSharePct > 0 && (
            <InfoRow label="דמי ניהול מרווחים %" value={fund.dmeiNihul.actual.profitSharePct} pct bold color="#7c3aed" />
          )}
          <InfoRow label="דמי ניהול מצבירה ₪" value={fund.dmeiNihul?.actual?.dmeiTzvAmt} money />
          <InfoRow label="דמי ניהול אחרים" value={fund.dmeiNihul?.actual?.dmeiAchrim} money />
          <InfoRow label="סה״כ דמי ניהול" value={fund.dmeiNihul?.actual?.total} money bold color={cs.accent} />
          <InfoRow label="ממוצע דמ״נ הפקדה" value={fund.dmeiNihul?.actual?.avgHafPct} pct />
          {fund.dmeiNihul?.structure?.map((s, i) => s.hatava && (
            <InfoRow key={i} label="הטבה בדמי ניהול" value={`${s.hatavaAmt}% עד ${s.hatavaEnd || "—"}`} bold color="#16a34a" />
          ))}
          <InfoRow label="דמי ניהול מנהל תיקים" value={fund.dmeiNihul?.actual?.dmeiNiulMenael} money />
        </SubSection>
      </TwoCol>
      {hasDebt && (
        <AlertBanner icon="⚠️"
          text={`פיגור בתשלום! ${fund.debts.months ? fund.debts.months + " חודשים" : ""} | סוג: ${fund.debts.sugHov || "—"} | סכום: ${fmtMoney(fund.debts.totalDebt) || "—"}`}
          color="#991b1b" bg="#fee2e2" border="#fecdd3" />
      )}
      {hasLoan && (fund.loans?.length > 1 ? (
        <AlertBanner icon="💰"
          text={`${fund.loans.length} הלוואות | יתרה כוללת: ${fmtMoney(fund.loans.reduce((s, l) => s + (l.balance || 0), 0)) || "—"}`}
          color="#1d4ed8" bg="#eff6ff" border="#bfdbfe" />
      ) : (
        <AlertBanner icon="💰"
          text={`הלוואה: ${fmtMoney(fund.loan.amount) || "—"} | יתרה: ${fmtMoney(fund.loan.balance) || "—"} | עד: ${fund.loan.endDate || "—"}`}
          color="#1d4ed8" bg="#eff6ff" border="#bfdbfe" />
      ))}
    </>
  );
}
